import type { ResourceConfig } from "../types";

export const classSessionFeedbackConfig = {
  displayName: "课程反馈",
  category: "class-session-feedback",
  permissions: {
    "read:all": {
      label: "访问课程反馈",
      description: "可以访问课程反馈功能（学员专用）",
    },
    "write:own": {
      label: "提交课程反馈",
      description: "可以提交自己的课程反馈评价",
    },
    "view:all": {
      label: "查看所有反馈内容",
      description: "可以查看学员提交的反馈内容和统计数据（管理员/教师专用）",
    },
    "view:own": {
      label: "查看自己的反馈统计",
      description: "可以查看与自己相关的反馈统计数据（教练专用）",
    },
  },
  navigation: {
    path: "/student-feedback",
    label: "课程反馈",
    icon: "MessageSquare" as const,
    requiredPermissions: ["read:all"] as const,
    alwaysVisibleForRoles: ["student"] as const,
    excludedRoles: ["admin", "teacher", "reviewer", "coach-manager", "coach", "sales"] as const,
    order: 5,
  },
} satisfies ResourceConfig;
